import { useLocation } from 'react-router-dom';
import PageHeading from './PageHeading';

/**
 * Module hub header — Line-1 title/trail + Line-2 peer sub-nav (building style).
 * Pass `resolveNav({ pathname, search })` returning `{ trail, subPages }`.
 */
export default function ModulePageHeading({ resolveNav, title, showBack = false, ...rest }) {
  const { pathname, search } = useLocation();
  const { trail, subPages } = resolveNav({ pathname, search });
  return (
    <PageHeading title={title} trail={trail} subPages={subPages} showBack={showBack} {...rest} />
  );
}
